import { union } from "superstruct";

import InstagramGridLayoutSettingsSchema from "./InstagramGridLayoutSettingsSchema";
import InstagramListingLayoutSettingsSchema from "./InstagramListingLayoutSchema";
import InstagramMasonryLayoutSettingsSchema from "./InstagramMasonryLayoutSettingsSchema";
import InstagramSlideLayoutSettingsSchema from "./InstagramSlideLayoutSettingsSchema";

const InstagramDisplaySettingsSchema = union([
    InstagramGridLayoutSettingsSchema,
    InstagramListingLayoutSettingsSchema,
    InstagramSlideLayoutSettingsSchema,
    InstagramMasonryLayoutSettingsSchema,
]);

export default InstagramDisplaySettingsSchema;
